import SCHCTemplateFormatAPIToForm from './SCHCTemplateFormatAPIToForm';
import SCHCTemplateFormatFormToAPI from './SCHCTemplateFormatFormToAPI';

export interface SCHCTemplateFormatI<I, O, T1> {
  input: I | null;
  output: O | null;

  generate(): void;
  rules(): Array<T1>;
  get generatedForm(): O | null;
}

const SCHCTemplateLibrary = {
  FormatFormToAPI: SCHCTemplateFormatFormToAPI,
  FormatAPIToForm: SCHCTemplateFormatAPIToForm,
};

export default SCHCTemplateLibrary;
